export var RowGutter;
(function (RowGutter) {
    RowGutter["None"] = "none";
    RowGutter["Sm"] = "sm";
    RowGutter["Lg"] = "lg";
})(RowGutter || (RowGutter = {}));
export var RowJustifyContent;
(function (RowJustifyContent) {
    RowJustifyContent["Around"] = "around";
    RowJustifyContent["Between"] = "between";
    RowJustifyContent["Center"] = "center";
    RowJustifyContent["End"] = "end";
    RowJustifyContent["Evenly"] = "evenly";
    RowJustifyContent["Start"] = "start";
})(RowJustifyContent || (RowJustifyContent = {}));
export var RowAlignItems;
(function (RowAlignItems) {
    RowAlignItems["Center"] = "center";
    RowAlignItems["End"] = "end";
    RowAlignItems["Start"] = "start";
    RowAlignItems["Stretch"] = "stretch";
})(RowAlignItems || (RowAlignItems = {}));
export var RowCssClasses;
(function (RowCssClasses) {
    RowCssClasses["Base"] = "iress-row";
    RowCssClasses["Justifyaround"] = "iress-row--justify-around";
    RowCssClasses["Justifybetween"] = "iress-row--justify-between";
    RowCssClasses["Justifycenter"] = "iress-row--justify-center";
    RowCssClasses["Justifyend"] = "iress-row--justify-end";
    RowCssClasses["Justifyevenly"] = "iress-row--justify-evenly";
    RowCssClasses["Justifystart"] = "iress-row--justify-start";
    RowCssClasses["Aligncenter"] = "iress-row--align-center";
    RowCssClasses["Alignend"] = "iress-row--align-end";
    RowCssClasses["Alignstart"] = "iress-row--align-start";
    RowCssClasses["Alignstretch"] = "iress-row--align-stretch";
})(RowCssClasses || (RowCssClasses = {}));
//# sourceMappingURL=row.types.js.map